import { Ask } from '../Ask/ask.service';
import { ModulesManagerService } from '../Module/modules-manager.service';


export class Chat {
  private Id: number = 0;
  private askId: number;
  private userId: number;
  private displayName: string;
  private message: string = "";
  private createdAt: Date = new Date();
  private currentAsk: Ask = null;
  private modifiedAt: Date;
  private document: Document = null;
  private maxTryBeforLongSleep = 5;
  private maxLongSleep = 5;
  constructor(private manager: ModulesManagerService, Data: any = null) {
    if (Data != null) {
      this.Hydrate(Data)
    }
  }

  async Hydrate(Data, UpdateAnnex = false) {
    // hydrate les setter 

    for (const [propertie, values] of Object.entries(Data))
      this[this.manager.Tool.capitalizeFirstChar(propertie)] = values


    if (UpdateAnnex) {
      //this.loadDocument()
    }
    await this.getAsk()
  }

  private load = false
  private longSleep = false
  private call = 0
  private longSleepDone = 0

  get isBroken() {
    return false;
    return this.longSleepDone > this.maxLongSleep//++ buju bug chargement infinie ?
  }

  async loadDocument() {
    if (this.longSleep || this.load || this.Id <= 0 || this.Content != "img" || this.document != null || this.isBroken) return;
    if (this.call == this.maxTryBeforLongSleep) {
      this.longSleep = true
      await this.manager.Tool.sleep(30000)
      this.load = true
      this.longSleep = false
      this.call = 0
      this.longSleepDone++

    }
    if (this.Id > 0) {
      this.call++
      this.load = true
      this.document = (await this.manager.GetModuleData("Documents", 0, "Chat", this.Id))[0]
      if (!this.document) await this.manager.Tool.sleep(1000)

    }
    this.load = false
  }

  get AskId(): number {
    return this.askId
  }

  set AskId(val: number) {
    this.askId = val
  }

  get UserId(): number {
    return this.userId
  }

  set UserId(val: number) {
    this.userId = val
  }

  get CreatAtFormatedDate(): string {
    return this.createdAt["getFromFormat"](this.manager.Trad.Parse("STR_FULLDATE"));
  }

  set CreatedDate(value) {
    this.createdAt = new Date(value);
  }


  set ModifiedDate(value) {
    if (value != null && value > 0) this.modifiedAt = new Date(value);
  }

  get ModifieAtFormatedDate(): string {
    return this.modifiedAt != null ? this.modifiedAt["getFromFormat"](this.manager.Trad.Parse("STR_FULLDATE")) : "";
  }

  get IsOwner(): boolean {
    if (!this.manager.Usr.isLoged)
      return this.currentAsk?.OwnerId == this.UserId

    return this.UserId == this.manager.Usr.UserId
  }

  get DisplayName(): string {
    return this.displayName
  }

  set DisplayName(val: string) {
    this.displayName = val
  }

  get Content(): string {
    return this.message.includes("#system#") ? this.manager.Trad.ParseSystemMsg(this.message) : this.message
  }

  set Content(val: string) {
    this.message = val
  }




  get exportData() {
    return {
      Id: this.Id > 0 ? this.Id : 0,
      Content: this.Content,
      AskId: this.askId,
      ModifiedDate: this.modifiedAt == null ? 0 : this.modifiedAt.getTime(),
      CreatedDate: this.createdAt?.getTime()
    }
  }

  async getAsk() {
    if (this.currentAsk == null && this.AskId > 0)
      this.currentAsk = (await this.manager.GetModuleData("Asks", this.AskId)) as Ask
  }

  public canDisplayDocument(Type: string) {
    return this.getDocument()?.canDisplayAs(Type)
  }

  public getDocument(): any {
    this.loadDocument()
    return this.document || { PictureSrc: this.manager.Documents.DefautPicture, canDisplayAs: (e) => true }
  }
}
